import { Theme } from '@mui/material';

const useStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  container: {
    display: 'flex',
    height: '150px',
    minWidth: '315px',
    maxWidth: '450px',
    padding: '16px',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '16px',
    flex: '1 0 0',
    borderRadius: '4px',
    background: theme.palette.common.white,
    [theme.breakpoints.down('md')]: {
      maxWidth: 'unset',
      width: '100%',
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'flex-start',
    paddingRight: '24px',
  },
  radioGrpContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxHeight: '245px',
    maxWidth: '350px',
    overflowY: 'scroll',
    [theme.breakpoints.down('md')]: {
      maxWidth: 'unset',
    },
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
    cursor: 'pointer',
  },
  lastStepContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'center',
    textAlign: 'center',
  },
});

export default useStyles;
